import { createReducer } from '@reduxjs/toolkit';
import * as MediaPlayerActions from '../actions/MediaPlayerActions';

// @TODO rewrite the complete mediaPlayer ... It is fragile and super complex

// Note: the following is just a fallback in case the db can't be reached. But I assume that nothing would work if this would happen... But better save then sorrow, right?
// Note: This will be reset as soon as getAvailableStreams returned
const availableStreams = [{
    streamId: 'antena_1',
    streamName: 'Normal',
    metaId: 'antena_1',
    semiPro: false,
    pro: false,
    sources: [
        { src: 'https://www.antena1.com.br/stream/stream/1;', type: 'audio/mp4; codecs="mp4a.40.5"' }, // aac 64k; absolute URLs let the app use these stream resources too.
        { src: 'https://www.antena1.com.br/stream/stream/1;', type: 'audio/aacp' }, // aac 64k
        { src: 'https://www.antena1.com.br/stream/stream/2;', type: 'audio/mpeg' }, // mp3 96k
    ],
}];

const defaultStreamId = 'antena_1';
const defaultCurrentStream = availableStreams.find((stream) => stream.streamId === defaultStreamId);

const initialState = {
    shouldBePlaying: false,
    isLive: false,
    playerStatus: '',
    availableStreams,
    currentStreamId: defaultStreamId,
    currentStream: defaultCurrentStream,
    currentSources: defaultCurrentStream.sources,
    videoPrerollAdTagUrl: null,
    videoPrerollOpen: false,
    videoPrerollPlayed: false,
};

const mediaPlayer = createReducer(initialState, (builder) => {
    builder
        .addCase(MediaPlayerActions.PLAY_MEDIA_PLAYER, (state) => {
            state.shouldBePlaying = true;
        })
        .addCase(MediaPlayerActions.MEDIA_PLAYING, (state) => {
            state.playerStatus = 'playing';
        })
        .addCase(MediaPlayerActions.MEDIA_LOADING, (state) => {
            state.playerStatus = 'loading';
        })
        /*
        MEDIA_LOADED is not used by the current playerStatus implementation. It may be useful
        again if player readiness needs to be represented separately from loading/playing.
        */
        .addCase(MediaPlayerActions.PAUSE_MEDIA_PLAYER, (state) => {
            // There is no stop function; the stream is automatically halted after 5 seconds.
            state.shouldBePlaying = false;
            state.playerStatus = 'paused';
        })
        .addCase(MediaPlayerActions.MEDIA_ENDED, (state) => {
            state.shouldBePlaying = false;
            state.playerStatus = 'ended';
        })
        .addCase(MediaPlayerActions.PLAY_MEDIA_FROM_SOURCE_WITH_META, (state, action) => {
            state.currentSources = action.payload.sources;
            state.shouldBePlaying = true;
            state.isLive = 'otherMedia';
        })
        .addCase(MediaPlayerActions.PLAY_LIVE, (state) => {
            state.currentSources = state.currentStream.sources;
            state.isLive = true;
            state.shouldBePlaying = true;
        })
        .addCase(MediaPlayerActions.REQUEST_VIDEO_PREROLL, (state, action) => {
            state.videoPrerollAdTagUrl = action.payload.adTagUrl;
            state.videoPrerollOpen = true;
            state.videoPrerollPlayed = true;
        })
        .addCase(MediaPlayerActions.COMPLETE_VIDEO_PREROLL, (state) => {
            state.videoPrerollOpen = false;
        })
        .addCase(MediaPlayerActions.SET_CURRENT_STREAM, (state, action) => {
            state.currentStreamId = action.payload.streamId;
            state.currentStream = state.availableStreams.find((stream) => stream.streamId === action.payload.streamId);
        })
        .addCase(MediaPlayerActions.SET_AVAILABLE_STREAMS, (state, action) => {
            // Reset current stream if it is absent from the refreshed stream list.
            let newCurrentStream = action.payload.availableStreams.find((stream) => stream.streamId === state.currentStreamId);

            if (!newCurrentStream) {
                // Fall back to the first stream that is neither PRO nor semi-PRO.
                newCurrentStream = action.payload.availableStreams.find((stream) => !stream.pro && !stream.semiPro);
            }

            state.availableStreams = action.payload.availableStreams;
            state.currentStreamId = newCurrentStream.streamId;
            state.currentStream = newCurrentStream;
            state.currentSources = newCurrentStream.sources;
        })
        .addCase(MediaPlayerActions.SET_IS_LIVE, (state, action) => {
            state.isLive = action.payload.isLive;
        })
        .addCase(MediaPlayerActions.MEDIA_ERROR, (state) => {
            state.shouldBePlaying = false;
            state.playerStatus = 'error';
        });
});

export default mediaPlayer;
